import { render } from "./SignUpBack.vue?vue&type=template&id=89529ebe&scoped=true&ts=true"
import script from "./SignUpBack.vue?vue&type=script&lang=ts"
export * from "./SignUpBack.vue?vue&type=script&lang=ts"

import "./SignUpBack.vue?vue&type=style&index=0&id=89529ebe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89529ebe"]])

export default __exports__